if (!window.Promise) {
    window.Promise = require('es6-promise');
}

if (!Array.from) {
    Array.from = require('array-from');
}

require('es6-object-assign').polyfill();
require('object.values').shim();

require('picturefill')();
require('picturefill/dist/plugins/mutation/pf.mutation');

require('script-loader!custom-event-polyfill');



// WEBPACK FOOTER //
// ./src/js/lib/polyfills.js